module.exports = __webpack_public_path__ + "img/track_vessel.b39bbf24.svg";